import AddCustomRfiDocument from './AddCustomRfiDocument.component';

export default AddCustomRfiDocument;
